<template lang="pug">
    .smart-image
      img(:src="srcUrl", v-if="loaded", @load="doneLoading(1)")
      .placeholder(v-else="")
        b-spinner(type="grow")
</template>

<script>

export default {
  name: 'loader',
  data() {
    return {
      loaded: false,
    };
  },
  props: ['srcUrl'],
  computed: {
  },
  methods: {
    doneLoading() {
      console.log('Done Loading');
      this.loaded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.smart-image {
  width: 100%;
  .placeholder {
    width: 100%;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/widgets/SmartImage.vue